import { useState, useCallback } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const algoPlan = httpsCallable(functions, 'sensexAlgoPlan');

export default function useDailyPlan() {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generatePlan = useCallback(async (capital, riskPct = 1.0, dailyGainPct = 2.0) => {
    try {
      setLoading(true);
      setError(null);
      const result = await algoPlan({
        capital,
        risk_pct: riskPct,
        daily_gain_pct: dailyGainPct,
      });
      setPlan(result.data);
      return result.data;
    } catch (err) {
      console.error('Daily plan error:', err);
      setError(err.message || 'Plan generation failed');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { plan, loading, error, generatePlan };
}
